/* eslint-disable prettier/prettier */
import { MoreVertical, Edit, UserPlus, Ban, Building } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';

export const CompanyRow = ({ company, onEdit, onAddUser, onToggleStatus }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="cursor-pointer sm:w-[90%] flex items-center px-4 py-3 bg-white border-b border-x hover:bg-light">
      <div className="w-[55%] sm:w-[40%] flex items-center gap-3">
        {company.logo ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${company.logo}`}
            alt="logo"
            className="hidden transform scale-110 rounded-full w-9 h-9 sm:block"
          />
        ) : (
          <div className="items-center justify-center hidden rounded-full w-9 h-9 sm:flex bg-muted text-muted-foreground">
            <Building className="w-5 h-5 text-primary" />
          </div>
        )}

        <p className="font-medium text-primary">{company.name}</p>
      </div>
      <div className="w-[40%] sm:w-[20%] text-muted-foreground">{company.country ? company.country.name : "undefined" } </div>
      <div className="hidden sm:w-[20%] text-muted-foreground  sm:block ">{company.usersCount}</div>
      <div className="hidden sm:w-[10%] sm:block">
        <span
          className={`px-2 py-1 text-sm rounded-full ${company.isActive ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}
        >
          {company.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className="w-[5%] sm:w-[10%] flex justify-end relative">
        <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
          <MoreVertical className="w-5 h-5 text-muted-foreground" />
        </button>
        {isOpen && (
          <div
            ref={dropdownRef}
            className="absolute right-0 z-10 w-40 mt-2 bg-white border rounded shadow-md"
          >
            <button
              onClick={onAddUser}
              className="flex items-center w-full gap-2 px-4 py-2 text-sm hover:bg-highlight"
            >
              <UserPlus className="w-4 h-4" /> Add User
            </button>
            <button
              onClick={onEdit}
              className="flex items-center w-full gap-2 px-4 py-2 text-sm hover:bg-highlight"
            >
              <Edit className="w-4 h-4" /> Edit
            </button>
            <button
              onClick={onToggleStatus}
              className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-600 hover:bg-highlight"
            >
              <Ban className="w-4 h-4" /> {company.isActive ? 'Disable' : 'Enable'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
